export interface MarkdownContent {
  html?: string | null;
  markdown?: string | null;
  plaintext?: string | null;
}

export interface MediaRef {
  _publishUrl?: string | null;
  type: string;
}

export interface DocumentRef {
  _publishUrl?: string | null;
  type: string;
}

export interface ContentFeatureModel {
  __typename?: 'QsgContentFeatureModel' | 'QsgContentfeatureModel';
  _id?: string | null;
  _path?: string | null;
  title?: MarkdownContent | null;
  content: MarkdownContent[];
  media?: MediaFeatureModel[];
  layout: string;
  layoutIndex?: number;
  layoutColumnBreakSpecifier?: string;
  layoutColumnBreakSpecifierIndex?: number;
  isLayoutDisclaimer?: boolean | null;
  flowTextBelowMedia?: boolean | null;
  centerMediaAroundLayout?: boolean | null;
  centerTextAroundLayout?: boolean | null;
}

export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface MediaFeatureModel {
  __typename?: 'QsgMediaFeatureModel' | 'QsgMediafeatureModel';
  _id?: string | null;
  _path?: string | null;
  mediaType: MediaType;
  asset: MediaRef;
  altText?: string | null;
  caption?: MarkdownContent | null;
  posterImage?: MediaRef | null;
  externalUrl?: string | null;
  autoplay?: boolean | null;
  loop?: boolean | null;
  muted?: boolean | null;
  showControls?: boolean | null;
  forceMaxWidth?: number | null;
}

export interface DisclaimerFeatureModel {
  __typename?: 'QsgDisclaimerFeatureModel' | 'QsgDisclaimerfeatureModel';
  _id?: string | null;
  _path?: string | null;
  disclaimerId: string;
  disclaimerType: string;
  disclaimerContent: MarkdownContent;
}

export interface IconlistFeatureModel {
  __typename?: 'QsgIconlistFeatureModel' | 'QsgIconlistfeatureModel';
  _id?: string | null;
  _path?: string | null;
  items: MarkdownContent[];
  splitAtNumber?: number | null;
}

export interface UnknownFeatureModel {
  __typename?: 'QsgUnknownFeatureModel';
  _id?: string | null;
  _path?: string | null;
}

export type FeatureModelUnion =
  | ContentFeatureModel
  | MediaFeatureModel
  | DisclaimerFeatureModel
  | IconlistFeatureModel
  | UnknownFeatureModel;

export interface SectionModel {
  _path?: string | null;
  originalSectionId?: string | null;
  sectionId: string;
  sectionName: string;
  sectionTitle?: MarkdownContent | null;
  sectionFooter?: MarkdownContent | null;
  features?: FeatureModelUnion[] | null;
  subsections?: SectionModel[] | null;
  sectionDescription?: string | null;
  sectionKeywords?: MarkdownContent[] | null;
}

export interface QsgV1Model {
  _path?: string | null;
  modelId: string;
  modelYear: string;
  modelName: string;
  coverImage?: MediaRef | null;
  jellybean?: MediaRef | null;
  pdfFile?: DocumentRef | null;
  sections?: SectionModel[] | null;
}

export interface VehicleModel {
  modelId: string;
  modelName: string;
  modelYear: string;
}

export interface NavigationSection {
  _path: string;
  sectionId: string;
  sectionName: string;
  sectionTitle?: MarkdownContent | null;
  features?: NavigationFeature[] | null;
  subsections?: NavigationSection[] | null;
  originalSectionId?: string | null;
  sectionDescription?: string | null;
  sectionKeywords?: MarkdownContent[] | null;
}

export interface NavigationFeature {
  _id: string;
  _path: string;
}

export interface NavigationGuide {
  _path?: string | null;
  modelId: string;
  modelYear: string;
  modelName: string;
  coverImage?: MediaRef | null;
  jellybean?: MediaRef | null;
  pdfFile?: DocumentRef | null;
  sections?: NavigationSection[] | null;
}

export interface GetModelYearsResponse {
  modelYears: string[];
}

export interface GetModelsByYearResponse {
  modelNames: string[];
}

export interface GetQSGByYearAndModelResponse {
  guides: QsgV1Model[];
}

export interface GetAllModelsResponse {
  models: VehicleModel[];
}

export interface GetQSGNavigationResponse {
  navigation: NavigationGuide[];
}

export interface GetSectionByPathResponse {
  section: SectionModel;
}

export enum Layout {
  DEFAULT = 'default',
  TWO_COLUMN = 'two-column',
  MEDIA_LEFT = 'media-left',
  MEDIA_RIGHT = 'media-right',
}

export type GetAllModelsQueryResult = {
  getAllQsgModels: GetAllModelsResponse;
};

export type GetQSGByYearAndModelQueryResult = {
  getQsgByYearAndModel: GetQSGByYearAndModelResponse;
};

export type GetQSGNavigationQueryResult = {
  getQsgNavigation: GetQSGNavigationResponse;
};

export type GetSectionByPathQueryResult = {
  getQsgSectionByPath: GetSectionByPathResponse;
};

export type GetQSGSearchResultsQueryResult = {
  getQsgSearchResults: GetQsgSearchResultsResponse;
};

export type GetQsgSearchResultsResponse = {
  results: QsgSearchResult[];
  totalCount: number;
  page: number;
  limit: number;
  hasMore: boolean;
};

export type QsgSearchResult = {
  chain: SectionChainItem[];
  sectionId: string;
  sectionName: string;
  sectionTitle: MarkdownContent;
  resultTitle: MarkdownContent;
  resultContent: SearchResultContent;
};

export type SectionChainItem = {
  sectionId: string;
  sectionName: string;
  sectionTitle: MarkdownContent;
};

export type SearchResultContent = {
  html?: string | null;
  plaintext?: string | null;
  trimmed?: string | null;
};

export type GetAllDisclaimersQueryResult = {
  getAllQsgDisclaimers: DisclaimerFeatureModel[];
};
